export const INDUSTRIES = [
  "Construction",
  "Mass Transit",
  "Firearms",
  "Pumps/Valves",
  "Energy",
  "Automotive",
  "Oil",
  "Food Processing",
  "Cutlery",
  "Entertainment",
  "Aerospace",
  "Pool Covers",
  "Dental",
  "Military",
  "Mining",
  "Equipment",
  "Structural",
  "Medical",
  "Marine",
  "Recreation",
];

export const FOUNDRIES = [
  {
    id: 1,
    label: "IPC - Utah",
    company: "IPC Foundry Group - Utah",
    address: {
      street: "1156 W 400 N",
      city: "Lindon",
      state: "UT",
      zip: "84052",
    },
    cell: "801-785-0233",
    fax: "",
    website: "www.ipcfoundry.com",
  },
  {
    id: 2,
    label: "IPC - Marble Falls",
    company: "IPC Foundry Group - Texas",
    address: {
      street: "2605 Commerce Street",
      city: "Marble Falls",
      state: "TX",
      zip: "78654",
    },
    cell: "830-693-3518",
    fax: "830-693-7558",
    website: "www.ipcfoundry.com",
  },
  { id: 3, label: "IPC - Global Manufacturing" },
];

export const FOUNDRY_NAMES = FOUNDRIES.flatMap((f) => f.label);
